export const EnabledFilterOptions = [
    {
        value: 'true',
        label: 'Активен'
    },
    {
        value: 'false',
        label: 'Неактивен'
    }
]
